"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FacebookPixel = void 0;
class FacebookPixel {
    constructor(pixelId) {
        this.pixelId = pixelId;
        console.log(`FacebookPixel with ${this.pixelId}`);
    }
    add() {
        console.log('Add facebook pixel');
        if (!fbq) {
            console.error('fbq not found');
            return;
        }
        fbq('init', this.pixelId);
        const imgSrc = `https://www.facebook.com/tr?id=${this.pixelId}&ev=PageView&noscript=1`;
        this.addImg(imgSrc);
    }
    addImg(url) {
        const img = new Image();
        img.src = url;
        img.width = 1;
        img.height = 1;
        img.style.display = 'none';
        document.head.appendChild(img);
    }
}
exports.FacebookPixel = FacebookPixel;
